import type { Dict } from "./en";

const hi: Partial<Dict> = {
  app_name: "Nexstays",
  tagline: "बिना रजिस्टर के अपना PG चलाएं",
  login_title: "मालिक लॉगिन",
  phone_label: "मोबाइल नंबर",
  whatsapp_number: "WhatsApp नंबर",
  send_whatsapp_code: "WhatsApp पर कोड भेजें",
  check_whatsapp: "अपना कोड देखने के लिए WhatsApp खोलें। कोड 10 मिनट चलेगा।",
  whatsapp_soon: "WhatsApp लॉगिन अभी सेट हो रहा है। अभी ईमेल से लॉगिन करें।",
  demo_phone_hint: "डेमो WhatsApp नंबर (कोड 123456):",
  phone_verified: "WhatsApp से सत्यापित",
  join_requests: "जुड़ने के अनुरोध",
  visits: "विज़िट",
  listing: "सार्वजनिक लिस्टिंग",
  listing_help: "अपना PG प्रकाशित करें ताकि किरायेदार इसे खोज सकें और जुड़ने का अनुरोध भेज सकें।",
  publish_listing: "मेरा PG खोज में दिखाएं",
  city: "शहर",
  locality: "इलाका",
  pg_for: "PG किसके लिए",
  amenities: "सुविधाएं",
  contact_phone: "संपर्क नंबर (वैकल्पिक)",
  resident_link: "क्या आप किरायेदार हैं? यहां लॉगिन करें",
  email_label: "ईमेल पता",
  change_email: "ईमेल बदलें",
  check_inbox: "अपना इनबॉक्स (और स्पैम) देखें। कोड 5 मिनट में खत्म होगा।",
  otp_resent: "नया कोड भेजा गया",
  login_footer: "सिर्फ PG मालिक लॉगिन करते हैं। किरायेदारों को बिना लॉगिन लिंक मिलता है।",
  send_otp: "OTP भेजें",
  otp_label: "6 अंकों का OTP डालें",
  verify_login: "जांचें और लॉगिन करें",
  otp_sent_to: "OTP भेजा गया",
  change_number: "नंबर बदलें",
  resend_in: "दोबारा भेजें",
  resend_otp: "OTP दोबारा भेजें",
  demo_otp_hint: "डेमो खाता: कोड 123456 डालें",
  demo_account: "डेमो खाता आज़माएं",
  nav_dashboard: "डैशबोर्ड",
  nav_beds: "बेड",
  nav_tenants: "किरायेदार",
  nav_rent: "किराया",
  nav_more: "अन्य",
  save: "सेव करें",
  cancel: "रद्द करें",
  delete: "हटाएं",
  confirm: "पक्का करें",
  add: "जोड़ें",
  edit: "बदलें",
  back: "वापस",
  next: "आगे",
  done: "हो गया",
  search: "खोजें",
  all: "सभी",
  loading: "लोड हो रहा है...",
  retry: "फिर से कोशिश करें",
  optional: "वैकल्पिक",
  logout: "लॉग आउट",
  language: "भाषा",
  saved: "सेव हो गया",
  st_paid: "भुगतान हुआ",
  st_partial: "आंशिक भुगतान",
  st_pending: "बाकी है",
  st_overdue: "देरी से",
  bed_vacant: "खाली",
  bed_occupied: "भरा हुआ",
  bed_maintenance: "मरम्मत",
  ob_title: "अपना PG सेट करें",
  ob_step_property: "प्रॉपर्टी",
  ob_step_rooms: "कमरे व बेड",
  ob_step_done: "तैयार",
  property_name: "PG का नाम",
  address: "पता",
  rent_due_day: "किराया देने की तारीख",
  proration: "महीने के बीच में आने पर",
  proration_prorated: "दिनों के हिसाब से",
  proration_full: "पूरे महीने का",
  proration_help: "अगर किरायेदार 15 तारीख को आए, तो सिर्फ बचे दिनों का किराया लें।",
  room_no: "कमरा नं.",
  floor: "मंज़िल",
  sharing: "कमरे में बेड",
  rent_per_bed: "प्रति बेड किराया",
  deposit: "जमा राशि",
  add_room: "यह कमरा जोड़ें",
  copy_similar: "ऐसे ही और कमरे बनाएं",
  copy_count: "ऐसे कितने और कमरे?",
  rooms_added: "बनने वाले कमरे",
  no_rooms_yet: "अभी कोई कमरा नहीं जोड़ा। ऊपर भरें और जोड़ें दबाएं।",
  create_rooms: "कमरे बनाएं",
  ob_done_title: "आपका PG तैयार है!",
  ob_done_text: "अब बेड पर किरायेदार जोड़ें। हर महीने किराया अपने आप बनेगा।",
  go_dashboard: "डैशबोर्ड पर जाएं",
  hello: "नमस्ते",
  occupancy: "भराव",
  beds_filled: "बेड भरे",
  collected: "वसूला",
  pending: "बाकी",
  overdue: "देरी से",
  this_month: "इस महीने",
  of_due: "में से",
  six_month_chart: "पिछले 6 महीने की वसूली",
  due: "देय",
  overdue_list: "देरी वाला किराया",
  no_overdue: "कोई बकाया नहीं। बहुत बढ़िया!",
  upcoming_moveouts: "जल्द जाने वाले",
  no_moveouts: "अगले 30 दिनों में कोई नहीं जा रहा",
  remind: "याद दिलाएं",
  open_complaints: "खुली शिकायतें",
  quick_add_tenant: "किरायेदार जोड़ें",
  quick_collect: "किराया लें",
  rooms_beds: "कमरे व बेड",
  add_rooms: "कमरे जोड़ें",
  room: "कमरा",
  bed: "बेड",
  no_rooms: "अभी कोई कमरा नहीं",
  no_rooms_text: "किरायेदार जोड़ने के लिए पहले कमरे जोड़ें।",
  tap_vacant: "किरायेदार जोड़ने के लिए खाली बेड दबाएं",
  mark_maintenance: "मरम्मत में डालें",
  mark_vacant: "खाली करें",
  delete_room: "कमरा हटाएं",
  tenants: "किरायेदार",
  active: "रह रहे हैं",
  moved_out: "चले गए",
  add_tenant: "किरायेदार जोड़ें",
  no_tenants: "अभी कोई किरायेदार नहीं",
  no_tenants_text: "पहला किरायेदार किसी खाली बेड पर जोड़ें।",
  tenant_name: "पूरा नाम",
  select_bed: "बेड चुनें",
  no_vacant_beds: "कोई खाली बेड नहीं। पहले कमरे जोड़ें।",
  monthly_rent: "मासिक किराया",
  move_in_date: "आने की तारीख",
  expected_move_out: "जाने की संभावित तारीख",
  id_type: "पहचान पत्र",
  id_last4: "ID के आखिरी 4 अंक",
  id_none: "नहीं लिया",
  consent_label: "किरायेदार ने जांच के लिए ID देने की सहमति दी",
  prorated_note: "पहले महीने का किराया दिनों के हिसाब से",
  joined: "आए",
  rent_history: "किराया इतिहास",
  payments: "भुगतान व रसीदें",
  no_payments: "अभी कोई भुगतान नहीं",
  receipt: "रसीद",
  mark_paid: "भुगतान दर्ज करें",
  share_link: "किरायेदार लिंक भेजें",
  share_link_help: "किरायेदार बिना लॉगिन किराया, रसीद और मेन्यू देख सकता है। लिंक 30 दिन चलेगा।",
  revoke_link: "पुराने लिंक बंद करें",
  copy_link: "लिंक कॉपी करें",
  link_copied: "लिंक कॉपी हुआ",
  send_whatsapp: "WhatsApp पर भेजें",
  whatsapp_note: "WhatsApp में तैयार संदेश खुलेगा। आप भेजें दबाएं।",
  edit_tenant: "किरायेदार बदलें",
  rent_change_note: "किराया बदलाव अगले महीने से लागू होगा।",
  next_rent: "नया किराया",
  move_out: "बाहर जाना",
  id_details: "ID व सहमति",
  consent_at: "सहमति दर्ज",
  id_doc: "ID की फोटो",
  upload_id: "ID फोटो अपलोड करें",
  view_id: "देखें",
  id_upload_off: "इस प्रॉपर्टी पर ID फोटो अपलोड बंद है (सुझाया गया)। सिर्फ ID प्रकार और आखिरी 4 अंक रखे जाते हैं।",
  erase_data: "निजी जानकारी मिटाएं (DPDP)",
  erase_help: "नाम, फोन और ID हटाए जाएंगे। किराया व रसीद रिकॉर्ड हिसाब के लिए रहेंगे।",
  erased: "निजी जानकारी मिटा दी गई",
  settlement: "हिसाब",
  collect_rent: "किराया वसूली",
  generate_rent: "किराया बनाएं",
  generated: "किराया रिकॉर्ड तैयार",
  no_rent_records: "इस महीने का किराया नहीं",
  no_rent_text: "किराया हर 1 तारीख को अपने आप बनता है। अभी बनाने के लिए दबाएं।",
  amount: "राशि",
  mode: "भुगतान का तरीका",
  cash: "नकद",
  upi: "UPI",
  bank: "बैंक",
  deposit_adjustment: "जमा राशि से",
  paid_on: "भुगतान तारीख",
  note: "टिप्पणी",
  full_amount: "पूरा",
  half_amount: "आधा",
  balance: "बाकी",
  payment_saved: "भुगतान दर्ज हुआ",
  download_receipt: "रसीद डाउनलोड करें",
  prorated: "दिनों के हिसाब से",
  days: "दिन",
  moveout_title: "बाहर जाना व हिसाब",
  moveout_date: "जाने की तारीख",
  deductions: "कटौती",
  add_deduction: "कटौती जोड़ें",
  deduction_label: "कारण (जैसे नुकसान)",
  adjust_deposit: "बाकी किराया जमा राशि से काटें",
  rent_outstanding: "बाकी किराया",
  deposit_applied: "किराए में लगी जमा राशि",
  refund: "किरायेदार को वापसी",
  still_owes: "किरायेदार पर बाकी",
  confirm_moveout: "बाहर जाना पक्का करें",
  moveout_done: "किरायेदार चला गया। बेड खाली है।",
  more: "अन्य",
  food_menu: "खाने का मेन्यू",
  announcements: "सूचनाएं",
  complaints: "शिकायतें",
  settings: "सेटिंग्स",
  audit_log: "गतिविधि लॉग",
  breakfast: "नाश्ता",
  lunch: "दोपहर का खाना",
  dinner: "रात का खाना",
  today: "आज",
  menu_saved: "मेन्यू सेव हुआ",
  new_announcement: "नई सूचना",
  title: "शीर्षक",
  message: "संदेश",
  post: "पोस्ट करें",
  no_announcements: "अभी कोई सूचना नहीं",
  share_whatsapp: "WhatsApp पर शेयर करें",
  new_complaint: "शिकायत दर्ज करें",
  no_complaints: "कोई शिकायत नहीं। सब ठीक है!",
  category: "श्रेणी",
  cat_electrical: "बिजली",
  cat_plumbing: "पानी/नल",
  cat_food: "खाना",
  cat_cleaning: "सफाई",
  cat_wifi: "वाईफाई",
  cat_other: "अन्य",
  description: "विवरण",
  tenant_optional: "किरायेदार (वैकल्पिक)",
  c_open: "खुली",
  c_in_progress: "काम जारी",
  c_resolved: "हल हुई",
  start_work: "शुरू करें",
  resolve: "हल करें",
  reopen: "फिर खोलें",
  property_settings: "प्रॉपर्टी सेटिंग्स",
  id_upload_toggle: "ID फोटो अपलोड की अनुमति",
  id_upload_warning: "आधार/ID फोटो रखना डेटा सुरक्षा (DPDP) जोखिम है। ज़रूरत न हो तो बंद रखें।",
  add_property: "नई प्रॉपर्टी जोड़ें",
  delete_property: "प्रॉपर्टी हटाएं",
  profile: "आपकी प्रोफ़ाइल",
  your_name: "आपका नाम",
  email: "ईमेल",
  privacy: "गोपनीयता व डेटा",
  delete_account: "मेरा खाता व सारा डेटा हटाएं",
  delete_account_help: "सभी PG, किरायेदार और रिकॉर्ड हमेशा के लिए हटाने को DELETE लिखें।",
  no_activity: "अभी कोई गतिविधि नहीं",
  language_help: "ऐप की भाषा चुनें।",
  pub_hello: "नमस्ते",
  pub_rent_status: "आपका किराया",
  pub_history: "पिछले 6 महीने",
  pub_receipts: "आपकी रसीदें",
  pub_menu_today: "आज का मेन्यू",
  pub_no_menu: "मेन्यू अभी नहीं डाला गया",
  pub_notices: "PG की सूचनाएं",
  pub_invalid: "यह लिंक बंद या पुराना हो गया है। PG मालिक से नया लिंक मांगें।",
  pub_footer: "आपके PG मालिक ने Nexstays से भेजा। लॉगिन की ज़रूरत नहीं।",
  receipt_footer: "रसीद किराया मिलने की पावती है, टैक्स इनवॉइस नहीं।",
};

export default hi;
